import React from 'react';

export const dispatchResize = () => {
  window.dispatchEvent(new CustomEvent('resize'));
};

export const getPointOfEvent = <T>(
  e: React.PointerEvent<T> | React.MouseEvent<T> | React.TouchEvent<T>
) => {
  if ('pageX' in e && 'pageY' in e) {
    return {
      x: e.pageX,
      y: e.pageY,
    };
  } else {
    return {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  }
};

export const preventDefault = (e: { preventDefault: () => void }) => {
  e.preventDefault();
};
